import { mdiPurse, mdiTestTube } from "@mdi/js";
import { TileGrid } from "../../components/common/TileGrid";
import { IFarm } from "../../interfaces/Farm";
import {
	SampleSource,
	UpcomingSamplesFilterValues,
} from "../../interfaces/Sample";
import { DynamicRoutes } from "../../routes";
import SampleList, {
	ViewAllSamplesLink,
} from "../../components/common/SampleList";
import { OrderSamplesLink } from "../../components/common/OrderSamplesLink";
import { ButtonWrapper } from "../../components/common/ButtonWrapper";
import { useAllowedToPlaceSampleOrders } from "../../context/AuthorizationsProvider";

export function FarmSamples({ farm }: { farm: IFarm }) {
	const allowedToPlaceSampleOrders = useAllowedToPlaceSampleOrders();

	return (
		<>
			<TileGrid>
				<SampleList
					source={SampleSource.farm}
					id={farm.id}
					maxResults={3}
					label="SampleReport_Header_NewestSamples"
					iconPath={mdiTestTube}
					statusFilter={UpcomingSamplesFilterValues.NoUpcomingSamples}
				/>
				<SampleList
					source={SampleSource.farm}
					id={farm.id}
					label="Samples_UnusedSamples"
					iconPath={mdiPurse}
					statusFilter={
						UpcomingSamplesFilterValues.OnlyUpcomingSamples
					}
				/>
			</TileGrid>
			<ButtonWrapper>
				{allowedToPlaceSampleOrders && (
					<OrderSamplesLink
						source={SampleSource.farm}
						farmId={farm.id}
						className="my-1"
					/>
				)}
				<ViewAllSamplesLink
					link={DynamicRoutes.Farm.get(farm.id)}
					className="ml-2 my-1"
				/>
			</ButtonWrapper>
		</>
	);
}
